import { useMemo } from "react";
import {
  TextField,
  DatagridConfigurable,
  useTheme,
  NumberField,
} from "react-admin";
import salesmanJournalFilterList from "../../components/salesmanJournals/filter/salesmanJournalFilterList";
import getFirstAndLastDateOfCurrentMonth from "../../utils/firstLastDate";
import DownloadAction from "../../components/tableListActions/DownloadActionNew";
import MyDatagridBody from "../../components/common/MyDatagridBody";
import SalesmanJournalFooterList from "../../components/salesmanJournals/footer/SalesmanJournalFooterList";
import SalesmanJournalExpandList from "../../components/salesmanJournals/expand/SalesmanJournalExpandList";
import ManualReportList from "../../components/reports/ManualReportList";
import useCompanyScopedListFilters from "../../hooks/useCompanyScopedListFilters";

const [firstDate, lastDate] = getFirstAndLastDateOfCurrentMonth();

const SalesmanJournalList = () => {
  const [theme] = useTheme("light");
  const { permissions, canSeeCompanyColumn, filterDefaultValues } =
    useCompanyScopedListFilters({
      start_date: firstDate,
      end_date: lastDate,
      "salesmen.active": "1",
    });

  const list = useMemo(
    () => (
      <ManualReportList
        title="mine.label.salesman_journal"
        empty={false}
        actions={<DownloadAction />}
        filters={salesmanJournalFilterList(permissions)}
        // filterDefaultValues={{ status: 1 }}
        // queryOptions={{ meta: { sort: ["created_at DESC"] } }} // overide default sort
        filterDefaultValues={filterDefaultValues}
        requiredFilters={["start_date", "end_date"]}
      >
        <DatagridConfigurable
          body={<MyDatagridBody footer={<SalesmanJournalFooterList />} />}
          bulkActionButtons={false}
          expand={<SalesmanJournalExpandList />}
          sx={{
            "& .RaDatagrid-expandedPanel > td": {
              p: 0,
              bgcolor: theme !== "dark" ? "#E7EBF0" : "grey.800",
            },
          }}
        >
          {canSeeCompanyColumn ? (
            <TextField source="company.alias" label="mine.label.company" />
          ) : null}
          <TextField source="name" label="mine.label.name" />
          <TextField source="code" label="mine.label.receipt_no" />
          <NumberField source="total_amount" />
        </DatagridConfigurable>
      </ManualReportList>
    ),
    [theme, permissions, canSeeCompanyColumn, filterDefaultValues]
  );
  return list;
};

export default SalesmanJournalList;
